var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.header))]),_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"src":_vm.getImgProxySrc(_vm.src),"stencil-props":{
      handlers: {},
      movable: false,
      scalable: false
    },"stencil-size":_vm.stencilSize,"default-position":_vm.defaultPosition,"stencilComponent":_vm.stencilComponent,"image-restriction":"stencil"},on:{"change":_vm.cropChange}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }